import styled from '@emotion/styled';
import { TabList } from 'src/domains/common/components/tabs/tabs';
import { mainColors } from 'src/assets/colors';
import { ColumnOneOfTwoV2 } from 'src/domains/layouts/shared/layout/Layout.style';

export const ComplianceConfigurationWrapper = styled('div', { label: 'ComplianceConfigurationWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
    min-height: 0;
    width: 100%;
    height: 100%;
`;

export const ComplianceConfigurationPage = styled(ColumnOneOfTwoV2, { label: 'ComplianceConfigurationPage' })`
    flex: 1 1 0%;
    min-height: 0;
    max-height: calc(100vh - 88px);
    height: calc(100vh - 88px);
    overflow: hidden;
    padding-top: 0 !important;
`;

export const ComplianceConfigurationToolbar = styled('div', { label: 'ComplianceConfigurationToolbar' })`
    flex: 0 0 auto;
    margin: 0 -16px;
    padding: 24px 16px 20px;
    background-color: ${mainColors.grays.gray100};
    border-bottom: 1px solid ${mainColors.grays.gray200};
`;

export const ComplianceConfigurationTabs = styled(TabList, { label: 'ComplianceConfigurationTabs' })`
    flex: 0 0 auto;
    margin: 16px 0 0;
    width: max-content;
    background-color: transparent;
    padding: 0;
    height: auto;
`;

export const ComplianceConfigurationContent = styled('div', { label: 'ComplianceConfigurationContent' })`
    flex: 1 1 0%;
    min-height: 0;
    overflow-y: auto;
    padding-top: 24px;
    padding-bottom: 48px;
`;
